import type { ZohoContact } from '@deltasuite/zoho-client';

// Brief §7: "ONE-CLICK DIAL — preferred number first". Mobile beats landline.
export function preferredNumber(contact: ZohoContact): {
  value: string;
  kind: 'mobile' | 'phone';
} | null {
  if (contact.Mobile && contact.Mobile.trim()) {
    return { value: contact.Mobile.trim(), kind: 'mobile' };
  }
  if (contact.Phone && contact.Phone.trim()) {
    return { value: contact.Phone.trim(), kind: 'phone' };
  }
  return null;
}

// Strip spaces/dashes; tel: tolerates them but the hash looks cleaner.
export function telHref(raw: string): string {
  return `tel:${raw.replace(/[\s-]/g, '')}`;
}
